module.exports = __webpack_public_path__ + "img/Bergen-Logistics-Logo-400x200.eps2028129.9074ffb2.png";